import React from 'react'
import TasksCard from './TasksCard';
import {useState, useEffect} from 'react';
import {Buffer} from 'buffer';
import { Rings } from 'react-loader-spinner'

export default function TasksCompleted() {

    const [executions, setExecution] = useState([]);
    const CUSTOMER_API_URL = process.env.REACT_APP_CUSTOMER_API_ENDPOINT
    const user = process.env.REACT_APP_USER
    const pass = process.env.REACT_APP_PASS
    const base64encodedData = Buffer.from(`${user}:${pass}`).toString('base64');
    
    const searchExecutions = async(name) => {
        const response = await fetch(`${CUSTOMER_API_URL}/customer_execute/executions/?search=${name}`, {
          method: 'GET',
          headers: {'Content-Type': 'application/json','Authorization': 'Basic ' + base64encodedData}})
        const data = await response.json();
        setExecution(data);
      }
    
    useEffect(() => {
      searchExecutions('');
    }, [])


  return (
    <div className="col-lg-8 col-md-6 mb-md-0 mb-4">
          <div className="card">
            <div className="card-header pb-0">
              <div className="row">
                <div className="col-lg-6 col-7">
                  <h6>Tasks Completed</h6>
                  <p className="text-sm mb-0">
                    <i className="fa fa-check text-info" aria-hidden="true"></i>
                    <span className="font-weight-bold ms-1">
                  {executions?.length > 0 ?
                    (
                    executions.length+" done" 
                    ) : (
                    "Yet to reduce your work load"
                    )
                    } 
                    </span> this month
                  </p>
                </div>
                <div className="col-lg-6 col-5 my-auto text-end">
                  <div className="dropdown float-lg-end pe-4">
                    <a className="cursor-pointer" id="dropdownTable" data-bs-toggle="dropdown" aria-expanded="false">
                      <i className="fa fa-ellipsis-v text-secondary"></i>
                    </a>
                    <ul className="dropdown-menu px-2 py-3 ms-sm-n4 ms-n5" aria-labelledby="dropdownTable">
                      <li><a className="dropdown-item border-radius-md" href="#">Action</a></li>
                      <li><a className="dropdown-item border-radius-md" href="#">Another action</a></li>
                      <li><a className="dropdown-item border-radius-md" href="#">Something else here</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body px-0 pb-2">
              <div className="table-responsive">
              {executions?.length > 0 ?
                    (
                <table className="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tasks</th>
                      <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Time Saved</th>
                      <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Money Saved</th>
                      <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">CO2 Saved</th>
                    </tr>
                  </thead>
                  <tbody>

                  {executions.map ((execution) => (
                        <TasksCard key={execution.id} execution={execution}/>
                      ))}
       
                  </tbody>
                </table>
                    ) : (
                        <table className="table align-items-center mb-0">
                        <tbody><tr><td>
                          <Rings
                          visible={true}
                          height="80"
                          width="80"
                          color="#4fa94d"
                          ariaLabel="rings-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          />
                        </td></tr></tbody>
                        </table>
                    )
                    }
              </div>
            </div>
          </div>
        </div>
  )
}
